import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 2,
  title: "Hard Water Minerals Create 'Invisible Soap Scale' That Traps Moisture and Disrupts pH",
  mechanism: <>
      Australian tap water contains calcium and magnesium—minerals that, when
      combined with soap, create an <strong data-id="element-126">insoluble substance</strong> called
      soap scale. You've seen this on shower walls (white buildup). But this
      same buildup forms on your toddler's skin at a{' '}
      <strong data-id="element-127">microscopic level</strong>. This invisible layer{' '}
      <strong data-id="element-128">blocks natural moisture regulation</strong>, traps bacteria, and
      physically <strong data-id="element-129">disrupts the skin's pH balance</strong>. It's not that
      the soap is bad—it's that hard water minerals{' '}
      <strong data-id="element-130">prevent soap from working</strong> as designed.
    </>,
  avatars: {
    jessica: <>
        This soap scale buildup is partly why your toddler's skin looks{' '}
        <strong data-id="element-131">dull and tight</strong>, not just irritated. You're dealing with
        a <strong data-id="element-132">moisture barrier issue</strong>, not a sensitivity issue.
      </>,
    michelle: <>
        Hard water is a <strong data-id="element-133">documented health variable</strong> in
        Australia. Filtering it isn't optional if you're optimizing everything
        else—it's <strong data-id="element-134">foundational</strong>.
      </>
  },
  bridge: <>
      Creams can moisturize the surface, but they <strong data-id="element-135">can't remove</strong>{' '}
      the soap scale barrier that prevents{' '}
      <strong data-id="element-136">natural moisture function</strong>.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80',
    alt: 'Microscopic view of mineral deposits and soap scale crystalline formations on a water surface, showing hard water mineral buildup'
  },
  imageOnLeft: true
};
export function Item2Section() {
  return <ItemSection data={data} data-id="element-137" />;
}